import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedAppModule } from '@shared/shared-app.module';
import { SharedModule } from '@pages/components/shared.module';
import { PagesModule } from '@pages/pages.module';
import { SignUpRoutingModule } from './sign-up-routing.modules';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    SharedModule,
    SharedAppModule,
    PagesModule,
    FormsModule,
    SignUpRoutingModule,
    ReactiveFormsModule
  ]
})
export class SignUpModule {}
